import { TIMELINE_DRAG_ATTR } from '../../../constants/frame-timeline-v4';
import type { CellAnchorT } from '../../../types/frame-timeline-v4';
export function dragTargetAt(target: EventTarget | null): Element | null {
  return target instanceof Element ? target.closest(`[${TIMELINE_DRAG_ATTR}]`) : null;
}
export function elementOf(target: EventTarget | null): Element | null {
  return target instanceof Element ? target : null;
}
export function frameUnderPointer(clientX: number, clientY: number): number | null {
  const cell = document.elementFromPoint(clientX, clientY)?.closest<HTMLElement>('[data-frame]');
  return cell ? Number(cell.dataset.frame) : null;
}
export function cellAnchorAt(clientX: number, clientY: number): CellAnchorT | null {
  const cell = document.elementFromPoint(clientX, clientY)?.closest<HTMLElement>('[data-frame]');
  if (!cell || cell.dataset.frame === undefined) {
    return null;
  }
  const rect = cell.getBoundingClientRect();
  return {
    frame: Number(cell.dataset.frame),
    left: rect.left,
    width: rect.width
  };
}
export function frameFromAnchor(clientX: number, anchor: CellAnchorT): number {
  return anchor.frame + Math.floor((clientX - anchor.left) / anchor.width);
}